export default class TextareaMaxLenght extends HTMLTextAreaElement {

    maxLenghtLabelElement = null;

    connectedCallback() {

        this.addEventListener("input", this.handleInput);

        this.maxLenghtLabelElement = document.createElement("div");

        this.maxLenghtLabelElement.classList.add("form-help-text");
        this.maxLenghtLabelElement.id = this.id + "_MaxLenghtLabel"
        this.maxLenghtLabelElement.innerText = this.dataset.maxlenghtText.replace("{COUNT}", this.maxLength);

        this.parentNode.insertBefore(this.maxLenghtLabelElement, this);

        this.setAttribute("aria-describedby", this.maxLenghtLabelElement.id);

    }

    disconnectedCallback() {

        this.removeEventListener("input", this.handleInput);

    }

    handleInput = () => {

        this.maxLenghtLabelElement.innerText = this.dataset.maxlenghtText.replace("{COUNT}", this.maxLength - this.value.length);

    }

}

customElements.define('textarea-maxlength', TextareaMaxLenght, { extends: 'textarea' });